import { render, staticRenderFns } from "./CadastroAssinaturas.vue?vue&type=template&id=b0734994&"
import script from "./CadastroAssinaturas.vue?vue&type=script&lang=js&"
export * from "./CadastroAssinaturas.vue?vue&type=script&lang=js&"
import style0 from "./CadastroAssinaturas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports